export const GoogleClientIdKey = Symbol('google:login')
